<template>
<div class="chapter">
<div class="inner_page">
<table width="100%;">
<tbody><tr>
<td style="width:27%;"> </td>
<td style="width:70%;"><p class="pre">They laugh that win.</p></td>
</tr>
</tbody></table>
<table width="100%;">
<tbody><tr>
<td style="width:30%;"> </td>
<td style="width:50%;"><p class="pre1">—John Bartlett, <i>Familiar Quotations</i></p></td>
</tr>
<tr>
<td style="width:30%;"> </td>
<td style="width:50%;"><p class="pre2">(attributed to W. Shakespeare)</p></td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm.vue?17037c46